import * as React from 'react';

export default function SpacesMenu ( props ) {
  return (
    <>
      {
        props.spaces.length > 1 &&
          <>
            <ul className="nav nav-tabs nav-tabs-fillup"  role="tablist" data-init-reponsive-tabs="dropdownfx">
              {
                props.spaces.map( ( position, index ) => {
                  const this_position = position.tab;
                  return (
                    <li key={this_position.tab_id.toString()} className="">
                      <a className={index == 0 ? 'active' : null} data-bs-toggle="tab" href="#"
                        data-bs-target={'#' + this_position.tab_id} style={{ color: '#626262' }}>
                        <span className="fw-normal fs-12 main-design-color">{this_position.title}</span>
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </>

      }
    </>

  )
}